"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFilteredReviewCategories = toFilteredReviewCategories;
const lodash_1 = require("lodash");
function toFilteredReviewCategories(categories) {
    return categories.map((category) => toFilteredReviewCategory(category));
}
function toFilteredReviewCategory(category) {
    return {
        ...category,
        reviews: category.reviews.map((review) => ({
            ...(0, lodash_1.pick)(review, ["name", "type", "description", "status", "availability", "checks"]),
            checks: Object.fromEntries(Object.entries(review.checks).map(([checkId, check]) => [
                checkId,
                (0, lodash_1.pick)(check, ["name", "status", "description", "designator"]),
            ])),
        })),
    };
}
//# sourceMappingURL=filtered.js.map